module.exports = __webpack_public_path__ + "static/media/Icons_faqs.83dcf1af.svg";